import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ButtonModule,
  CheckboxStandardModule,
  LinkModule
} from '@com-delta-idp/mnx-ui-kit';
import { OfferActionBannerComponent } from './offer-action-banner.component';

@NgModule({
  declarations: [OfferActionBannerComponent],
  imports: [CommonModule, ButtonModule, CheckboxStandardModule, LinkModule],
  exports: [OfferActionBannerComponent]
})
export class OfferActionBannerModule {}
